export default {
  GET_BRAND_LIST: '/auth/brand/list',
  GET_GOODS_LIST: '/auth/product/productList',
  GET_INCI_LIST: '/auth/trade/inci/findList',
  GET_PRODUCT_LIST: '/auth/trade/web/findList',
  GET_CONCEPT_LIST: '/auth/concept/search',
  GET_FORMULATION_LIST: '/auth/formulation/findList',
  GET_DOCUMENT: '/auth/document/findList',
  GET_TREND: '/auth/trend/findList',
  GET_MEDIA: '/auth/media/videos',
  // 模糊查找
  GET_SUGGEST_BRAND: '/auth/brand/findSuggest',
  GET_SUGGEST_PRODUCT: '/auth/product/findSuggest',
  GET_SUGGEST_FORMULATION: '/auth/formulation/findSuggest',
  GET_SUGGEST_INCI: '/auth/trade/inci/findSuggest',
  GET_SUGGEST_BASF_PRODUCT: '/auth/trade/findSuggest',
  GET_SUGGEST_DOCUMENT: '/auth/document/findSuggest',
  GET_SUGGEST_CONCEPT: '/auth/concept/findSuggest',
  GET_SUGGEST_GENERAL: '/auth/product/findSuggest',
  GET_SUGGEST_TREND: '/auth/trend/findSuggest',
  GET_SUGGEST_MEDIA: '/auth/media/search/findSuggest',
  GET_SUGGEST_EVENT: '/auth/event/findSuggest'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/search.js